import { render, staticRenderFns } from "./SupIndex.vue?vue&type=template&id=a6167316&"
import script from "./SupIndex.vue?vue&type=script&lang=js&"
export * from "./SupIndex.vue?vue&type=script&lang=js&"
import style0 from "./SupIndex.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports